<template>
  <div class="essay-detail-wrap">
    <div class="essay-detail">
      <div class="essay-base" v-if="info">
        <div class="essay-head">
          <div class="essay-title">{{ info.title }}</div>
          <span class="col" @click="addMyCollections">添加至论文集</span>
        </div>
        <div class="journal">
          《{{ info.journalNameZH }}》{{ info.pubYear }}年第{{ info.period }}期
        </div>
        <div class="essay-attr">
          <div class="item" v-if="info.authors">
            <div class="label">作者：</div>
            <div class="cont">
              {{ info.authors?info.authors.join("；"):'' }}
            </div>
            <div class="clear"></div>
          </div>
          <div class="item" v-if="info.organ">
            <div class="label">机构：</div>
            <div class="cont">{{ info.organ }}</div>
            <div class="clear"></div>
          </div>
          <div class="item">
            <div class="label">摘要：</div>
            <div class="cont">{{ info.summary }}</div>
            <div class="clear"></div>
          </div>
          <div class="item" v-if="info.keywords">
            <div class="label">关键词：</div>
            <div class="cont">
              {{ info.keywords?info.keywords.join("；"):'' }}
            </div>
            <div class="clear"></div>
          </div>
          <div class="item" v-if="info.fund">
            <div class="label">基金：</div>
            <div class="cont">{{ info.fund }}</div>
            <div class="clear"></div>
          </div>

          <div class="item" v-if="info.classifyCodes">
            <div class="label">分类号：</div>
            <div class="cont">{{ info.classifyCodes }}</div>
            <div class="clear"></div>
          </div>

          <div
            class="item"
            v-if="info.cnkiUrl || info.wanfangUrl || info.weipuUrl"
          >
            <div class="label">全文链接：</div>
            <div class="cont">
              <a
                :href="info.cnkiUrl"
                target="_blank"
                rel="noopener noreferrer"
                v-if="info.cnkiUrl"
              >
                <img src="~@/assets/cnki.png" alt="" />知网
              </a>
              <a
                :href="info.wanfangUrl"
                target="_blank"
                rel="noopener noreferrer"
                v-if="info.wanfangUrl"
              >
                <img src="~@/assets/wanfang.png" alt="" />万方
              </a>
              <a
                :href="info.weipuUrl"
                target="_blank"
                rel="noopener noreferrer"
                v-if="info.weipuUrl"
              >
                <img src="~@/assets/cpvip.png" alt="" />维普
              </a>
            </div>
            <div class="clear"></div>
          </div>
        </div>

        <div class="count">
          <span class="browseCount"
            ><i class="iconfont icon-liulan"></i
            >&nbsp;{{ numWan(info.browseQua) }}</span
          >
          <span
            class="collectCount"
            @click="collect"
            :class="{ collcected: isCollection }"
            ><i class="iconfont icon-shoucang"></i
            >&nbsp;{{ numWan(info.collectQua) }}</span
          >
          <span class="recCount" @click="praise" :class="{ reced: isPraise }"
            ><i class="iconfont icon-dianzan_kuai"></i
            >&nbsp;{{ numWan(info.praiseQua) }}</span
          >
        </div>
      </div>
      <div class="essay-base" v-else>
        <a-skeleton active :paragraph="{ rows: 8 }" />
      </div>

      <div class="rec-text" v-if="info && type === '2'">
        <div class="journal-info">
          <img :src="imgSiteUrl + info.jourImgUrl" alt="" />
          <div class="journal-name">《{{ info.journalNameZH }}》编辑部推荐</div>
          <div class="date">
            推荐日期：{{ info.pubTime ? info.pubTime.substring(0, 10) : "-" }}
          </div>
        </div>
        <div class="clear"></div>
        <div class="content" style="color:#666" v-html="info.content"></div>
        <div class="other">
          本文原创发布于知图平台。未经许可，禁止转载<br />
          编辑于2021-10-22
        </div>
      </div>

      <div class="essay-content">
        <div class="side-block">
          <side-block-title
            name="相关论文"
            style="padding: 0; font-weight: bold"
          >
          </side-block-title>
          <div class="title-line"></div>
          <div class="essay-list" v-if="likeEssays.length > 0">
            <div class="item" v-for="item in likeEssays" :key="item.id">
              <div style="margin-bottom: 10px;">
                <router-link
                  style="fontsize: 16px"
                  target="_blank"
                  :to="{
                    path: '/essay_detail',
                    query: { id: item.id, type: 1 },
                  }"
                  >{{ item.title }}</router-link
                >
              </div>
              <div>
                <router-link
                  style="color: #666; margin: 5px auto"
                  target="_blank"
                  :to="{
                    path: '/essay_detail',
                    query: { id: item.id, type: 1 },
                  }"
                  >{{ item.authors?item.authors.join("；")+" -":'' }}《{{ item.journalNameZH }}》-
                  {{ item.pubYear }}年第{{ item.period }}期发表</router-link
                >
              </div>
            </div>
          </div>
          <div class="essay-list" v-else>
            <a-empty :image="simpleImage" />
          </div>
        </div>
      </div>
    </div>

    <div class="right">
      <div class="side-block">
        <side-block-title
          name="收录此论文的论文集"
          style="padding: 0; height: 46px"
        >
          <a
            href="javascript:;"
            class="get-more"
            @click="getAnother(2)"
            v-if="linkPage > 1"
            ><sync-outlined style="margin-right: 3px" />换一批</a
          >
        </side-block-title>
        <div class="title-line"></div>
        <div class="articles" v-if="linkCollection.length > 0">
          <div class="item" v-for="item in linkCollection" :key="item.id">
            <div class="title">
              <router-link
                :to="{ path: '/collection_detail', query: { id: item.id } }"
                target="_blank"
                >{{ item.name }}</router-link
              >
            </div>
            <div class="date">
              {{ numWan(item.collectQua) }}人收藏 <a-divider type="vertical" />
              {{ numWan(item.articleQua) }}篇论文
            </div>
          </div>
        </div>
        <!-- <div class="articles" v-else>
          <a-empty :image="simpleImage" />
        </div> -->
        <div class="articles" v-else>
          <a-empty>
            <template #description>
              <span> 暂无数据 </span>
            </template>
          </a-empty>
        </div>
      </div>
    </div>
    <a-modal
      v-model:visible="visible"
      class="select-collection"
      centered
      width="400px"
      @ok="addEssayToMyCollections"
    >
      <template #title> 选择论文集 </template>
      <div
        class="list"
        style="
          border-bottom: 1px solid #f0f0f0;
          margin-bottom: 10px;
          padding-bottom: 5px;
        "
      >
        <div v-if="myCollections.length > 0">
          <div class="item" v-for="item in myCollections" :key="item.id">
            <a-checkbox :disabled="item.isArticle===1" :checked="selectedCollectionId.indexOf(item.id)>-1||item.isArticle===1" @change="(e)=>{selectCollection(e.target.checked,item.id)}">{{ item.name }}（{{ item.articleQua }}）</a-checkbox
            >
          </div>
        </div>
        <div v-else>
          <a-empty>
            <template #description>
              <span> 您还没有创建论文集 </span>
            </template>
          </a-empty>
        </div>
      </div>

      <div class="page" v-show="page.allSize > 10">
        <!-- <a-pagination
          v-model:current="page.currentPage"
          :total="page.allSize"
          :show-total="(total) => `共 ${page.allSize} 篇`"
          :page-size="1"
          show-quick-jumper
          @change="changePage"
        /> -->
        <a-pagination size="small" v-model:current="page.currentPage" simple :total="page.allSize" :page-size="10" @change="changePage" />
      </div>

      <div class="create" style="color: #e75934" @click="toCreate">
        <plus-outlined />创建论文集
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import config from "../../until/configs";
import Http from "../../until/http";
import { SyncOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { confirmLogin, getCookie } from "@/until/tools";
import { getLocalItem, messageTips, numWan } from "../../until/tools";
import SideBlockTitle from "@/components/SideBlockTitle.vue";
import { Empty } from "ant-design-vue";

export default defineComponent({
  components: {
    SideBlockTitle,
    SyncOutlined,
    PlusOutlined,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const id = computed(() => {
      return route.query.id;
    });
    const type = computed(() => {
      return route.query.type;
    });
    const sid = computed(() => {
      return getCookie("z_sid");
    });

    const userInfo = computed(() => {
      return getLocalItem("userInfo") || {};
    });

    const state = reactive({
      info: null,
      isPraise: false,
      isCollection: false,
      myCollections: [],
      page: {},
      visible: false,
      selectedCollectionId: [],
      likeEssays: [],
      likePage: 1,
      likeCurrentPage: 1,
      linkCollection: [],
      linkPage: 1,
      linkCurrentPage: 1,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      imgSiteUrl: config.imgSiteUrl, 
    });
    const toCreate = () => {
      router.push({ path: "/essay_create_collection",query:{needback:1,articleId:state.info.artiId ? state.info.artiId : id.value} });
    };
    const addMyCollections = () => {
      if (!sid.value) {
        confirmLogin();
        return false;
      }

      Http.addCollection({articleId:id.value}).then((res) => {
        if (res.articleAggList) {
          Object.assign(state, {
            myCollections: res.articleAggList,
            page: res.page,
          });
        }
      });

      Object.assign(state, {
        visible: true,
      });
    };

    const addEssayToMyCollections = () => {
      if (state.selectedCollectionId.length === 0) {
        messageTips("请选择论文集", 2);
        return false;
      }
      Http.addEssayToMyCollections({
        aggId: state.selectedCollectionId.join(","),
        id: state.info.artiId ? state.info.artiId : id.value,
      }).then((res) => {
        if (res) {
          if (res.status) {
            messageTips("添加成功", 3);
            Object.assign(state, {
              visible: false,
              selectedCollectionId: [],
              myCollections: [],
            });
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    };

    const collect = () => {
      if (!sid.value) {
        confirmLogin();
        return false;
      }
      let params = {
        resId: id.value,
        flag: state.isCollection ? 1 : 0,
        resUserId: state.info.userId ? state.info.userId : 0,
      };
      if (route.query.type == "2") {
        Http.setEssayCollectStatus2(params).then((res) => {
          if (res && res.success) {
            Object.assign(state.info, {
              collectQua: res.num,
            });
            Object.assign(state, {
              isCollection: res.num,
            });
          }
        });
      } else {
        Http.setEssayCollectStatus(params).then((res) => {
          if (res && res.success) {
            Object.assign(state.info, {
              collectQua: res.num,
            });
            Object.assign(state, {
              isCollection: res.num,
            });
          }
        });
      }
    };

    const praise = () => {
      if (!sid.value) {
        confirmLogin();
        return false;
      }
      let params = {
        resId: id.value,
        flag: state.isPraise ? 1 : 0,
        resUserId: state.info.userId ? state.info.userId : 0,
      };
      if (route.query.type == "2") {
        Http.setEssayPraiseStatus2(params).then((res) => {
          if (res && res.success) {
            Object.assign(state.info, {
              praiseQua: res.num,
            });
            Object.assign(state, {
              isPraise: res.num,
            });
          }
        });
      } else {
        Http.setEssayPraiseStatus(params).then((res) => {
          if (res && res.success) {
            Object.assign(state.info, {
              praiseQua: res.num,
            });
            Object.assign(state, {
              isPraise: res.num,
            });
          }
        });
      }
    };

    const getDetail = () => {
      let params = { id: id.value };
      if (userInfo.value.userId) {
        params.userId = userInfo.value.userId;
      }
      let funName = "";
      if (type.value === "1") {
        funName = "getEsseyDetail";
      } else if (type.value === "2") {
        funName = "getExpertRecDetail";
      } else {
        funName = "getEsseyDetail";
      }
      Http[funName](params).then((res) => {
        if (res.recommendation) {
          Object.assign(state, {
            info: res.recommendation,
            isCollection: res.isCollection,
            isPraise: res.isPraise,
          });
          document.title = res.recommendation.title + "-" + config.siteTitle;
        }
      });
    };

    const getLikeEssays = (pageNum = 1) => {
      Http.getLikeThisEssay({ id: id.value, pageNum }).then((res) => {
        if (res && res.articles) {
          Object.assign(state, {
            likeEssays: res.articles,
            likePage: res.condition.totalPages,
            likeCurrentPage: pageNum,
          });
        }
      });
    };

    const getCollectionByEssayId = (currentPage = 1) => {
      Http.getCollectionByEssyId({ id: id.value, currentPage }).then((res) => {
        if (res && res.list) {
          Object.assign(state, {
            linkCollection: res.list,
            linkPage: res.page.allPage,
            linkCurrentPage: currentPage,
          });
        }
      });
    };

    const getAnother = (type) => {
      if (type === 1) {
        if (state.likePage > state.likeCurrentPage) {
          getLikeEssays(state.likeCurrentPage + 1);
        } else {
          getLikeEssays(1);
        }
      } else if (type === 2) {
        if (state.linkPage > state.linkCurrentPage) {
          getCollectionByEssayId(state.linkCurrentPage + 1);
        } else {
          getCollectionByEssayId(1);
        }
      }
    };

    const changePage = (e) => {
     Http.addCollection({articleId:id.value,currentPage: e}).then((res) => {
        if (res.articleAggList) {
          Object.assign(state, {
            myCollections: res.articleAggList,
            page: res.page,
          });
        }
      });
    };

    const selectCollection = (checked,id)=>{
      let index = state.selectedCollectionId.indexOf(id);
      if(checked) {
        if(index===-1) {
          state.selectedCollectionId.push(id);
        }
      } else {
        state.selectedCollectionId.splice(index,1);
      }
    }

    watch(id, () => {
      Object.assign(state, {
        info: null,
        isPraise: false,
        isCollection: false,
        myCollections: [],
        selectedCollectionId: [],
        likeEssays: [],
        likePage: 1,
        likeCurrentPage: 1,
        linkCollection: [],
        linkPage: 1,
        linkCurrentPage: 1,
      });
      //   getDetail();
      //   getLikeEssays();
      //   getCollectionByEssayId();
    });

    onMounted(() => {
      getDetail();
      getLikeEssays();
      getCollectionByEssayId();
    });

    return {
      ...toRefs(state),
      toCreate,
      addMyCollections,
      collect,
      praise,
      addEssayToMyCollections,
      getAnother,
      numWan,
      type,
      changePage,
      selectCollection
    };
  },
});
</script>

<style lang="scss" >
.select-collection {
  .item {
    padding-bottom: 10px;
  }
  .create {
    cursor: pointer;
    width: 100px;
    padding-top: 0px;
  }
}
.ant-modal-footer {
  border-top: none;
  text-align: center;
}
</style>
<style lang="scss" scoped>
@import "@/scss/essay_detail.scss";
.side-block-title {
  border: none;
}
.title-line {
  height: 0.5px;
  background: #e8e8e8;
  margin-left: -20px;
  margin-right: -20px;
}
.page {
  text-align: center;
}
</style>